import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = {
  type: "submit",
  form: "capex-item-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'

    import { CapexItemEditorFormSubmitEventPayload } from '@Quest/Capex/Components/CapexItemEditor'
    import type { CapexItemEditorViewModel } from '@Quest/Capex/Components/CapexItemEditor'
    import type { CapexAccountReadModel } from '@Quest/Capex/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CapexItemEditor',
  props: {
    viewModel: {}
  },
  emits: ["form-submit"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const modalTitle = computed(() => vm.value.modalTitle)
    const confirmButtonLabel = computed(() => vm.value.confirmButtonLabel)

    const currencyLabel = computed(() => vm.value.currencyLabel)
    const accounts = computed<CapexAccountReadModel[]>(() => vm.value.accounts)

    // writable computeds (replace getter + setter pairs)

    const name = computed<string>({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    const accountId = computed<string | null>({
        get: () => vm.value.accountId,
        set: v => { vm.value.accountId = v }
    })

    const cost = computed<number | null>({
        get: () => vm.value.cost,
        set: v => { vm.value.cost = v }
    })

    const usefulLifeInYears = computed<number | null>({
        get: () => vm.value.usefulLifeInYears,
        set: v => { vm.value.usefulLifeInYears = v }
    })

    const acquisitionMonthIndex = computed<number | null>({
        get: () => vm.value.acquisitionMonthIndex,
        set: v => { vm.value.acquisitionMonthIndex = v }
    })

    const salvageValue = computed<number | null>({
        get: () => vm.value.salvageValue,
        set: v => { vm.value.salvageValue = v }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        emit(
            'form-submit',
            new CapexItemEditorFormSubmitEventPayload(
                vm.value.id,
                name.value,
                accountId.value,
                cost.value,
                usefulLifeInYears.value,
                acquisitionMonthIndex.value,
                salvageValue.value
            )
        )
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "capex-item-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        name.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { for: "account" }, "Account:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "account",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountId).value = $event)),
                      class: "form-control",
                      required: ""
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, "Select capex account", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (a) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: a.Id
                        }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, accountId.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", null, "Cost (" + _toDisplayString(currencyLabel.value) + "):", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cost).value = $event)),
                      class: "form-control",
                      required: "",
                      min: "0",
                      step: "any"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        cost.value,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Useful life (in years):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((usefulLifeInYears).value = $event)),
                      class: "form-control",
                      required: "",
                      min: "1",
                      step: "1"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        usefulLifeInYears.value,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, "Capex Acquisition Month (0 = Project Start):", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((acquisitionMonthIndex).value = $event)),
                      class: "form-control",
                      required: "",
                      min: "0",
                      step: "1"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        acquisitionMonthIndex.value,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, "Salvage value (" + _toDisplayString(currencyLabel.value) + "):", 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((salvageValue).value = $event)),
                      class: "form-control"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        salvageValue.value,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_16, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})